import React from 'react';
import classes from './FormErrorMessage.module.css';

interface ErrorMessageProps {
  errorMessage?: string;
  className?: string;
}

const ErrorMessage = ({ errorMessage, className }: ErrorMessageProps) => {
  if (!errorMessage) return null;

  return (
    <span className={className || classes.errorMessage}>{errorMessage}</span>
  );
};

export default ErrorMessage;
